import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function CheckOutlineCircle(props: IconProps) {
  const { baseColor = 'currentColor', ...svgProps } = props;
  return (
    <IconSvg
      {...svgProps}
      viewBox="0 0 52 52"
      stroke={baseColor}
      strokeWidth="1.5"
      fill="none"
    >
      <path d="M26 50C39.2548 50 50 39.2548 50 26C50 12.7452 39.2548 2 26 2C12.7452 2 2 12.7452 2 26C2 39.2548 12.7452 50 26 50Z" />
      <path d="M39.9303 21.127L24.539 36.5914C24.3825 36.7687 24.1842 36.9044 23.9651 37.0087C23.746 37.1027 23.5164 37.1548 23.2764 37.1548C23.0364 37.1548 22.8068 37.1027 22.5877 37.0087C22.3686 36.9148 22.1703 36.7687 22.0138 36.5914L13.5303 28.0766C13.3529 27.9096 13.2069 27.7114 13.1025 27.4818C12.9982 27.2522 12.946 27.0122 12.9355 26.7618C12.9355 26.5114 12.9773 26.2714 13.0608 26.0418C13.1547 25.8122 13.2903 25.6035 13.4677 25.4261C13.6451 25.2487 13.8538 25.1131 14.0834 25.0192C14.3129 24.9253 14.5529 24.8835 14.8034 24.8835C15.0538 24.8835 15.2938 24.9461 15.5129 25.0505C15.7321 25.1548 15.9408 25.3009 16.1077 25.4783L23.2764 32.6783L30.3408 25.5827L37.4051 18.487C37.7495 18.1427 38.2086 17.9548 38.6886 17.9548C39.1686 17.9548 39.6382 18.1427 39.9721 18.487C40.2955 18.8522 40.4729 19.3218 40.4625 19.8122C40.4625 20.3027 40.2642 20.7722 39.9303 21.1166V21.127Z" />
    </IconSvg>
  );
}
